import { PlanFeatureItem } from 'src/types';
import styles from './PlanCardContentItem.module.scss';
import { Icon as CommonIcon } from 'src/components/Icon/Icon';
import { SVG_SIZE_M, SVG_SIZE_S } from 'src/constants';

export const PlanCardContentItem = ({
  Icon,
  iconName,
  title,
  description,
  modelList,
}: PlanFeatureItem) => {
  return (
    <div className={styles.featureItem}>
      {iconName ? (
        <CommonIcon type={iconName} size={SVG_SIZE_M} />
      ) : (
        <Icon size={SVG_SIZE_M} />
      )}

      <div className={styles.textWrapper}>
        <div className={styles.title}>{title}</div>

        {!!description && (
          <span className={styles.description}>{description}</span>
        )}

        {modelList && (
          <div className={styles.modelList}>
            {modelList.map(({ title, iconName, Icon }, index) => (
              <div key={index} className={styles.modelItem}>
                {iconName ? (
                  <CommonIcon type={iconName} size={SVG_SIZE_S} />
                ) : (
                  <Icon size={SVG_SIZE_S} />
                )}

                <span className={styles.description}>{title}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
